exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lz-getData{display:block;width:84px;height:64px;margin:20px auto;text-align:center;color:#6f7ca9}.lz-getData:before{content:\" \";display:inline-block;width:26px;height:26px;margin:1px;border-radius:50%;border:2px solid #6f7ca9;border-color:#6f7ca9 transparent #6f7ca9 transparent;animation:lds-dual-ring 1.2s linear infinite;margin-bottom:5px}@keyframes lds-dual-ring{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n\n.lz-input textarea {\n    font-size: 1.4em;\n    font-weight: 600;\n    font-family: 'Open Sans',sans-serif !important;\n}", ""]);

// exports
